import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  editUserAccount,
  getUserAccountDetail,
} from '../../../../../../api/accounts';
import EditAccountUserDetailSection from './detailSection';
import DetailSectionOthersSection from './othersSection.tsx';
import AddSavedAddressModal from '../../../../../books/saved-address/addSavedAddressModal';
import AddSavedContactModal from '../../../../../books/saved-contacts/addSavedContactModal';
import { resendConfirmEmailService } from '../../../../../../api/auth';
import { useSnackbar } from 'notistack';

function EditAccountUser() {
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const user = new URLSearchParams(location.search).get('user');
  const account_name = new URLSearchParams(location.search).get('account_name');
  const account_number = new URLSearchParams(location.search).get(
    'account_number'
  );
  const [formData, setFormData] = useState<any>();
  const [isEdit, setIsEdit] = useState(false);
  const [showAddAddressModal, setShowAddAddressModal] = useState(false);
  const [showAddContactModal, setShowAddContactModal] = useState(false);

  function fetchData(user: string) {
    getUserAccountDetail(user)
      .then((response) => {
        if (!response?.data?.is_error) {
          let data = response.data.content;
          if (data?.is_vendor) {
            data.carriers = data?.carrier;
            data.fullCarriers = data?.carrier;
          }

          setFormData(data);
        }
      })
      .catch((e) => {});
  }
  useEffect(() => {
    if (user) {
      fetchData(user);
    }
  }, [user]);
  function handleSave() {
    let payload = formData;
    if (payload?.carriers) {
      // payload.carrier = payload.carriers;
      delete payload.carrier;
    }
    editUserAccount(payload)
      ?.then((response) => {
        if (!response?.data?.is_error) {
          fetchData(payload.username);
          setIsEdit(false);
        }
      })
      .catch((e) => {});
  }
  function resendEmailConfirmation(){
    // localStorage.setItem('resendEmailToken', formData?.email_confirm_token);
    resendConfirmEmailService({username: user})?.then((response) => {
      enqueueSnackbar('Email confirmation is resent.', {
        variant: 'success',
      });
      if(user){
        fetchData(user);
      }
    }).catch((e) => {

    })
  }
  return (
    <div className='container-fluid my-4'>
      <div className='row'>
        <div className='d-flex flex-row' style={{justifyContent: 'space-between'}}>
        <div className='d-flex flex-column'>
          <div className=' my-auto'>
            <nav className='my-auto' aria-label='breadcrumb'>
              <ol className='breadcrumb my-auto'>
                <li className='breadcrumb-item'>
                  <Link
                    className='link-no-style lex-16-300 text-decoration-none color-black'
                    to='/app/admin/accounts'
                  >
                    Accounts
                  </Link>
                </li>
                <li className='breadcrumb-item'>
                  <a
                    className='link-no-style lex-16-300 text-decoration-underline color-black'
                    onClick={() => {
                      window.history.go(-1); // Go back one page
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    {account_name}
                  </a>
                </li>
                <li
                  className='breadcrumb-item active lex-20-500 color-main'
                  aria-current='page'
                  id='account_bread_crumb'
                >
                  {`${formData?.first_name} ${formData?.last_name} (${account_name})`}
                </li>
              </ol>
            </nav>
          </div>
          <div className='lex-16-300 mt-2'>Account ID: {account_number}</div>
        </div>
          {formData?.is_email_confirmed === false &&
            <button className='resend_confirm_btn' onClick={resendEmailConfirmation}>
              Resend Email Confirmation
            </button>
          }
        
        </div>
        

        <EditAccountUserDetailSection
          formData={formData}
          setFormData={setFormData}
          isEdit={isEdit}
          fetchData={fetchData}
        />
        <DetailSectionOthersSection
          formData={formData}
          setFormData={setFormData}
          setShowAddContactModal={setShowAddContactModal}
          setShowAddAddressModal={setShowAddAddressModal}
          fetchData={fetchData}
        />
      </div>
      {showAddAddressModal && (
        <AddSavedAddressModal
          onClose={() => setShowAddAddressModal(false)}
          onSuccess={() => {
            setShowAddAddressModal(false);
            window.location.reload();
          }}
        />
      )}
      {showAddContactModal && (
        <AddSavedContactModal
          onClose={() => setShowAddContactModal(false)}
          onSuccess={() => {
            setShowAddContactModal(false);
            window.location.reload();
          }}
        />
      )}
      <div className='row justify-content-end px-2 py-4'>
        <button
          className='btn-ubbe-new-blue mt-2'
          style={{ width: 'max-content' }}
          onClick={handleSave}
        >
          Save
        </button>
      </div>
    </div>
  );
}

export default EditAccountUser;
